export default __webpack_public_path__ + "7c886680e0e43b715714f05881da141f.svg";